const ALLOWED_NOTE_TAGS = new Set([
	'P',
	'BR',
	'B',
	'STRONG',
	'I',
	'EM',
	'U',
	'S',
	'STRIKE',
	'UL',
	'OL',
	'LI',
	'H1',
	'H2',
	'H3',
	'H4',
	'H5',
	'H6',
	'BLOCKQUOTE',
	'DIV',
	'SPAN',
]);

const DISCARDED_NOTE_TAGS = new Set([
	'SCRIPT',
	'STYLE',
	'IFRAME',
	'OBJECT',
	'EMBED',
	'TEMPLATE',
	'NOSCRIPT',
	'SVG',
	'MATH',
]);

function appendSanitizedChildren(source: Node, target: Node, doc: Document) {
	for (const child of Array.from(source.childNodes)) {
		if (child.nodeType === Node.TEXT_NODE) {
			target.appendChild(doc.createTextNode(child.textContent ?? ''));
			continue;
		}
		if (child.nodeType !== Node.ELEMENT_NODE) continue;

		const tag = (child as Element).tagName.toUpperCase();
		if (DISCARDED_NOTE_TAGS.has(tag)) continue;
		if (!ALLOWED_NOTE_TAGS.has(tag)) {
			appendSanitizedChildren(child, target, doc);
			continue;
		}

		const clean = doc.createElement(tag);
		appendSanitizedChildren(child, clean, doc);
		target.appendChild(clean);
	}
}

export function sanitizeNoteHtml(raw: string): string {
	if (!raw) return '';
	const doc = new DOMParser().parseFromString(raw, 'text/html');
	const out = doc.createElement('div');
	appendSanitizedChildren(doc.body, out, doc);
	return out.innerHTML;
}

export function decodeHtmlEntities(value: string): string {
	if (!value) return '';
	return new DOMParser().parseFromString(value, 'text/html').documentElement.textContent ?? '';
}
